import { createAction } from '@lingoda/core';

export default createAction('booking/FETCH_ERROR_LEAD_TIME');
